// @spec DHB-STR-043
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ConsolidatedDataPage } from '@/features/datahub/consolidated/components/ConsolidatedDataPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/consolidated')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.consolidatedData'),
  }),
  component: ConsolidatedDataPage,
});
